import { GroupedEndpoints } from 'modules/endpoints/types';
import {
  getChainSubTypeTabs,
  getChainTypeTabs,
} from 'domains/chains/screens/ChainPage/constants/chainTypeTabs';
import { chainTypeToEndpointsKeyMap } from 'domains/chains/screens/ChainPage/constants/chainTypeToEndpointsKeyMap';

export const getPrivateChainTypeSelector = (endpoints: GroupedEndpoints) =>
  getChainTypeTabs()
    .filter(({ id }) => endpoints[chainTypeToEndpointsKeyMap[id]]?.length > 0)
    .map(({ id, title }) => ({
      value: id,
      label: title as string,
    }));

export const getPrivateChainSubTypeSelector = () =>
  getChainSubTypeTabs().map(({ id, title }) => ({
    value: id,
    label: title as string,
  }));
